module.exports = __webpack_public_path__ + "assets/img/img-hotel-04.9fbbef10.jpg";